import * as React from 'react'

import { CaretDownIcon, CaretUpIcon, Hidden, NativeLink, spacing, Visible } from 'main/ui'
import {
  ContentContainer,
  IconContainer,
  ReadMoreLink,
  ReadMoreLinkContainer,
  RegionContainer,
  StyledHeading,
  StyledText,
  TitleContainer,
} from './RegionText.styles'

interface IProps {
  city: string
  state: string
}

export default function RegionText(props: IProps) {
  const { city, state } = props
  const [readMore, setReadMore] = React.useState<boolean>(false)

  return (
    <RegionContainer>
      <ContentContainer>
        <TitleContainer>
          <StyledHeading>
            Top Child Care, Preschool & Daycare in {city ? `${city}, ${state}` : state}
          </StyledHeading>
        </TitleContainer>
        <Visible lg xl>
          <StyledText>
            Parents in {city ? city : state} use Wonderschool to find local in-home daycare, child
            care, and preschool options in their neighborhood. Wonderschool-affiliated child care
            programs — designated by our logo and verification badge on the listing — meet our&nbsp;
            <NativeLink href="/quality-safety" target="_blank">
              Quality & Safety Promise
            </NativeLink>
            , a set of standards that go above and beyond state licensing requirements for in-home
            programs.
          </StyledText>
        </Visible>
        <Hidden lg xl>
          <div>
            <StyledText css={{ marginTop: spacing.majorScale(-1) }}>
              Wonderschool programs in {city ? city : state} are diverse in structure and approach,
              but they all combine engaged teachers, thoughtful education design, and the warmth of
              an in-home program.
            </StyledText>
          </div>
          {!readMore && (
            <ReadMoreLinkContainer>
              <ReadMoreLink onClick={() => setReadMore(true)}>
                Read more
                <IconContainer>
                  <CaretDownIcon />
                </IconContainer>
              </ReadMoreLink>
            </ReadMoreLinkContainer>
          )}
          {readMore && (
            <>
              <div css={{ marginTop: spacing.majorScale(1) }}>
                <StyledText>
                  All the {city ? city : state} programs below meet Wonderschool’s&nbsp;
                  <NativeLink href="/quality-safety" target="_blank">
                    Quality & Safety Promise
                  </NativeLink>
                  , a set of standards that go above and beyond state licensing requirements for
                  in-home programs. program.
                </StyledText>
              </div>
              <div>
                <ReadMoreLinkContainer>
                  <ReadMoreLink onClick={() => setReadMore(false)}>
                    Close
                    <IconContainer>
                      <CaretUpIcon />
                    </IconContainer>
                  </ReadMoreLink>
                </ReadMoreLinkContainer>
              </div>
            </>
          )}
        </Hidden>
      </ContentContainer>
    </RegionContainer>
  )
}
